interface GridOverlayProps {
  width: number // in mm
  height: number // in mm
  gridSize: number // in mm
  zoom: number
  mmToPx: number
}

export function GridOverlay({ width, height, gridSize, zoom, mmToPx }: GridOverlayProps) {
  const scaledGridSize = gridSize * mmToPx * zoom
  const totalWidth = width * mmToPx * zoom
  const totalHeight = height * mmToPx * zoom

  const verticalLines = Math.floor(width / gridSize)
  const horizontalLines = Math.floor(height / gridSize)

  return (
    <svg
      className="absolute inset-0 pointer-events-none"
      width={totalWidth}
      height={totalHeight}
    >
      <defs>
        <pattern
          id="grid"
          width={scaledGridSize}
          height={scaledGridSize}
          patternUnits="userSpaceOnUse"
        >
          <path
            d={`M ${scaledGridSize} 0 L 0 0 0 ${scaledGridSize}`}
            fill="none"
            stroke="#e5e7eb"
            strokeWidth="0.5"
          />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#grid)" />
    </svg>
  )
}
